import styled from 'styled-components/macro';

import { tokens } from '@olist/design-system-tokens';
import { Input } from '@olist/united';

export default styled(Input)`
  font-family: ${tokens.fontFamily.soleil};
  font-size: ${tokens.fontSize[600]};
  margin-bottom: ${tokens.spacing[300]};
`;
